"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.candidatesSchema = void 0;
const zod_1 = require("zod");
const candidate_schema_1 = require("./candidate.schema");
exports.candidatesSchema = zod_1.z.array(candidate_schema_1.candidateSchema).min(1).describe("List of one or more candidates");
